export default function (instance) {
  return {
    searchRes(q) {
      return instance.post("api/search-api?q=" + q);
    },
  };
}
